import React, { Component } from 'react'

import { datePrimaryFormat } from '../util/datetime'
import { findImage } from './utils'

class TopicleCell extends Component {

  handleTopicleSelected = () => {
    const { topicle } = this.props
    this.props.onTopicleSelected(topicle)
  }

  render_img () {
    const { topicle } = this.props
    const media_groups = topicle.media_groups || topicle.featureimage || topicle.images || topicle.associations 
    let image = findImage(media_groups, {medium: 'image'})
    image = image || findImage(media_groups, {medium: 'graphic'})

    if (!image) {
      return null
    }
    
    return (
      <figure>
        <div className='TopicleCell-image-wrap' >
          <img src={image.url} title={image.creditline} alt='' />
        </div>
      </figure>
    )
  }

  render () {
    const { topicle, isSelected } = this.props
    const updated = topicle.version_created || topicle.versioncreated || topicle.updated

    return (
      <div className={'TopicleCell-article-cell ' + (isSelected ? 'selected' : '')} onClick={this.handleTopicleSelected}
           data-urn={topicle.urn || topicle.uri}>
        <div className='TopicleCell-image-and-text'>
          <div className='TopicleCell-subjects-and-time'>
            <time title={updated}>{datePrimaryFormat(updated)}</time>
          </div>
          <div className='TopicleCell-image-and-title'>
            { this.render_img() }
            <div className='TopicleCell-title-and-first-tags'>
              <h1>{topicle.title || topicle.headline}</h1>
            </div>
          </div>
        </div>
      </div>
    )
  }
}

export default TopicleCell



// WEBPACK FOOTER //
// ./src/probish/TopicleCell.js